import React from 'react';
import '../styles/ZwykPartners.css';

const ZwykPartners: React.FC = () => {
  return (
    <div className="zwyk-partners">
      <p className="zwyk-partners-title">
        Nasi Partnerzy:
      </p>
      <div className="zwyk-partners-logos">
        <a href="https://lesovik.eu?ref=zwyk" target="_blank" rel="noopener noreferrer" className="zwyk-partners-card">
          <img src={require('../assets/partners-logo/lesovik-logo.webp')} alt="Lesovik logo" className="zwyk-partners-logo" />
        </a>
        <a href="https://www.alpinus.eu?ref=zwyk" target="_blank" rel="noopener noreferrer" className="zwyk-partners-card">
          <img src={require('../assets/partners-logo/alpinus-logo.webp')} alt="Alpinus logo" className="zwyk-partners-logo" />
        </a>
        <a href="https://www.ptt.org.pl?ref=zwyk" target="_blank" rel="noopener noreferrer" className="zwyk-partners-card">
          <img src={require('../assets/partners-logo/ptt-logo.webp')} alt="PTT logo" className="zwyk-partners-logo" />
        </a>
      </div>
    </div>
  );
};

export default ZwykPartners;
